module.exports = __webpack_public_path__ + "img/HIW.8d71fff8.png";